export default Object.freeze({
  GoogleDrive: 'google-drive',
});
